var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7974_23604)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2547 1.38672L11.5142 2.14236C13.2961 3.21139 14.4116 4.73217 14.9951 6.28699C15.2171 5.78588 15.4808 5.30173 15.7258 4.81171L16.7068 5.79277C18.9089 7.99484 20.9997 11.2952 20.9997 14.4999C20.9997 18.7982 18.3499 21.5227 14.1103 21.9938L12.7204 22.1482L13.0237 20.783C13.261 19.715 13.3029 19.0166 13.2546 18.5279C13.1938 17.9124 12.9013 17.43 12.5381 16.9498C12.1896 16.489 11.8451 16.0284 11.5693 15.519C10.4336 16.4165 9.99361 17.2268 9.85325 17.8934C9.67331 18.7482 9.92819 19.6208 10.3942 20.5527L11.2162 22.1968L9.38926 21.9938C6.81338 21.7076 4.27541 19.987 3.27577 17.4753C2.23043 14.8487 2.96962 11.6695 6.34493 8.74418C8.58526 6.80258 9.77169 4.28573 10.2547 1.38672ZM11.5868 4.68757C10.8248 6.82679 9.36215 8.77587 7.65478 10.2556C4.74354 12.7786 4.48275 15.0994 5.13401 16.7357C5.61941 17.9554 6.66658 18.9587 7.9075 19.5277C7.77584 18.8894 7.74456 18.2014 7.89615 17.4814C8.2216 15.9356 9.33364 14.487 11.4698 13.1519L12.5468 12.4788L12.9485 13.6837C13.3005 14.7398 14.031 15.4864 14.6014 16.4133C15.2294 17.4338 15.3495 18.6032 15.2227 19.7723C17.8408 19.116 18.9997 17.1293 18.9997 14.4999C18.9997 12.2782 17.6596 10.0981 16.329 8.39401C15.7821 9.62186 14.6263 10.0547 13.4997 10.6179V8.99987C13.4997 7.63092 12.943 5.96221 11.5868 4.68757Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7974_23604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/calories.6807670ba4cd10a7c96b492b364b5c96.svg";
export { ForwardRef as ReactComponent };